<template>
  <div>
    <div
      class="modal fade"
      id="AddZadaniaModal"
      ref="modalEle"
      tabindex="-1"
      aria-labelledby="AddZadaniaModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="AddZadaniaModalLabel">
              Zadania
            </h5>

            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Zamknij"
            ></button>
          </div>

          <div class="modal-body">

            <div class="d-flex justify-content-between align-items-center mb-3">
              <span class="text-muted small">
                Zadania działu przypisanego do tablicy
              </span>

              <button
                v-if="sameDepartment"
                type="button"
                class="btn btn-primary"
                @click="addZadanie"
                :disabled="loading || saving"
              >
                <i class="bi bi-plus-lg me-1"></i>
                Dodaj zadanie
              </button>
            </div>

            <div v-if="errorMessage" class="alert alert-danger">
              {{ errorMessage }}
            </div>

            <div v-if="loading" class="text-center py-4">
              <span
                class="spinner-border spinner-border-sm me-2"
                role="status"
              ></span>
              Pobieranie zadań...
            </div>

            <div v-else class="custom-table table-responsive">
              <table class="table table-hover align-middle">
                <thead>
                  <tr>
                    <th style="width: 60px">#</th>
					<th style="width: 45px"></th>
                    <th>Tytuł</th>
                    <th>Opis</th>
                    <th style="width: 190px">Akcje</th>
                  </tr>
                </thead>

                <tbody>
                  <!-- Formularz nowego zadania -->
                  <tr v-if="addingNew">
                    <td>Nowe</td>
					<td></td>
                    <td>
                      <input
                        v-model="newZadanie.title"
                        type="text"
                        maxlength="255"
                        class="form-control"
                        placeholder="Tytuł zadania"
                        :class="{ 'is-invalid': validationErrors.title }"
                        @keyup.enter="saveNewZadanie"
                      />

                      <div
                        v-if="validationErrors.title"
                        class="invalid-feedback"
                      >
                        {{ validationErrors.title }}
                      </div>
                    </td>

                    <td>
                      <textarea
                        v-model="newZadanie.description"
                        class="form-control"
                        rows="2"
                        placeholder="Opis zadania"
                        :class="{ 'is-invalid': validationErrors.description }"
                      ></textarea>

                      <div
                        v-if="validationErrors.description"
                        class="invalid-feedback"
                      >
                        {{ validationErrors.description }}
                      </div>
                    </td>

                    <td>
                      <button
                        type="button"
                        class="btn btn-sm btn-success me-1"
                        @click="saveNewZadanie"
                        :disabled="saving"
                      >
                        <span
                          v-if="saving"
                          class="spinner-border spinner-border-sm me-1"
                        ></span>
                        Zapisz
                      </button>

                      <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary"
                        @click="cancelNewZadanie"
                        :disabled="saving"
                      >
                        Anuluj
                      </button>
                    </td>
                  </tr>

                  <!-- Istniejące zadania -->
                  <tr
                    v-for="(zadanie, index) in zadaniaLista"
                    :key="zadanie.id"
                  >
                    <td>{{ index + 1 }}</td>
<td>
  <input
    v-if="sameDepartment"
    v-model="selectedZadanieIds"
    type="checkbox"
    class="form-check-input"
    :value="Number(zadanie.id)"
    :disabled="saving || editingId === zadanie.id"
    :aria-label="`Wybierz zadanie ${zadanie.title}`"
  />
</td>
                    <td>
                      <template v-if="editingId === zadanie.id">
                        <input
                          v-model="zadanie.title"
                          type="text"
                          maxlength="255"
                          class="form-control"
                          :class="{
                            'is-invalid':
                              validationErrors['title_' + zadanie.id]
                          }"
                        />

                        <div
                          v-if="validationErrors['title_' + zadanie.id]"
                          class="invalid-feedback"
                        >
                          {{ validationErrors['title_' + zadanie.id] }}
                        </div>
                      </template>

                      <span v-else>{{ zadanie.title }}</span>
                    </td>

                    <td>
                      <template v-if="editingId === zadanie.id">
                        <textarea
                          v-model="zadanie.description"
                          class="form-control"
                          rows="2"
                        ></textarea>
                      </template>

                      <span v-else>
                        {{ zadanie.description || '—' }}
                      </span>
                    </td>

                    <td>
                      <template v-if="sameDepartment">
                        <button
                          v-if="editingId === zadanie.id"
                          type="button"
                          class="btn btn-sm btn-success me-1"
                          @click="updateZadanie(zadanie)"
                          :disabled="saving"
                        >
                          Zapisz
                        </button>

                        <button
                          v-else
                          type="button"
                          class="btn btn-sm btn-outline-info me-1"
                          @click="editZadanie(zadanie.id)"
                          :disabled="saving || addingNew"
                        >
                          <i class="bi bi-pencil me-1"></i>
                          Edytuj
                        </button>

                        <button
                          v-if="editingId === zadanie.id"
                          type="button"
                          class="btn btn-sm btn-outline-secondary"
                          @click="cancelEdit(zadanie)"
                          :disabled="saving"
                        >
                          Anuluj
                        </button>

                        <button
                          v-else
                          type="button"
                          class="btn btn-sm btn-danger"
                          @click="deleteZadanie(zadanie)"
                          :disabled="saving || addingNew"
                        >
                          <i class="bi bi-trash me-1"></i>
                          Usuń
                        </button>
                      </template>
                    </td>
                  </tr>

                  <tr v-if="!zadaniaLista.length && !addingNew">
                    <td colspan="4" class="text-center text-muted py-4">
                      Brak zadań. Kliknij „Dodaj zadanie”, aby utworzyć
                      pierwsze.
                    </td>
                  </tr>
                </tbody>
              </table>
			  
<div
  v-if="sameDepartment && selectedZadanieIds.length > 0"
  class="border rounded p-3 mt-3"
>
  <div class="fw-semibold mb-2">
    Tworzenie kart na podstawie wybranych zadań
  </div>

  <p class="text-muted small mb-3">
    Wybrano zadań: {{ selectedZadanieIds.length }}.
    Wybierz pracowników, dla których mają powstać karty.
  </p>

  <label class="form-label">Wybierz pracowników</label>

  <Multiselect
    v-model="selectedUsers"
    :options="availableUsersWithNames"
    :multiple="true"
    :searchable="true"
    :close-on-select="false"
    :clear-on-select="false"
    :preserve-search="true"
    label="full_name"
    track-by="id"
    placeholder="Wyszukaj i wybierz pracowników..."
    select-label="Dodaj"
    selected-label="Wybrano"
    deselect-label="Usuń wybór"
    no-options="Brak pracowników działu"
    no-result="Nie znaleziono pracownika"
  />
<div class="mt-3">
  <label for="bulk-project" class="form-label">
    Projekt <span class="text-muted">(opcjonalnie)</span>
  </label>

  <select
    id="bulk-project"
    v-model="selectedProjectId"
    class="form-select"
    :disabled="bulkCreating || saving"
  >
    <option :value="null">Bez przypisanego projektu</option>

    <option
      v-for="project in projects"
      :key="project.id"
      :value="Number(project.id)"
    >
      {{ project.number }}
    </option>
  </select>
</div>
  <div class="d-flex justify-content-between align-items-center mt-3">
    <span class="text-muted small">
      Do utworzenia: {{ selectedZadanieIds.length * selectedUsers.length }} kart
    </span>

    <button
      type="button"
      class="btn btn-primary"
      :disabled="!selectedUsers.length || bulkCreating || saving"
      @click="emitCreateSelectedTasks"
    >
      <span
        v-if="bulkCreating"
        class="spinner-border spinner-border-sm me-1"
      ></span>
      {{ bulkCreating ? 'Tworzenie...' : 'Utwórz zadania' }}
    </button>
  </div>
</div>			  
            </div>

          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-bs-dismiss="modal"
            >
              Zamknij
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Modal } from 'bootstrap';
import Multiselect from '@suadelabs/vue3-multiselect';

export default {
  name: 'AddZadaniaModal',
components: {

    Multiselect,
  },
  props: {
  projects: {
  type: Array,
  default: () => [],
},
    board: {
      type: Object,
      required: true,
    },
availableUsersWithNames: {
  type: Array,
  default: () => [],
},
    sameDepartment: {
      type: Boolean,
      default: false,
    },
  },

	data() {
	  return {
		selectedZadanieIds: [],
		selectedUsers: [],
		selectedProjectId: null,
		bulkCreating: false,
		modalObj: null,
		zadaniaLista: [],
		editingId: null,
		originalZadanie: null,
		addingNew: false,
		loading: false,
		saving: false,
		errorMessage: '',
		validationErrors: {},
		newZadanie: this.getEmptyForm(),
	  };
	},

  computed: {
    apiUrl() {
      return `/kanban/boards/${this.board.id}/zadania`;
    },
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
  },

  beforeUnmount() {
    if (this.modalObj) {
      this.modalObj.dispose();
      this.modalObj = null;
    }
  },

  methods: {
emitCreateSelectedTasks() {
  if (
    !this.sameDepartment ||
    this.bulkCreating ||
    this.selectedZadanieIds.length === 0 ||
    this.selectedUsers.length === 0
  ) {
    return;
  }

  const selectedTasks = this.zadaniaLista
    .filter(zadanie =>
      this.selectedZadanieIds.includes(Number(zadanie.id))
    )
    .map(zadanie => ({
      id: zadanie.id,
      title: zadanie.title,
      description: zadanie.description || '',
    }));

  this.$emit('create-selected-tasks', {
    tasks: selectedTasks,
    userIds: [
      ...new Set(this.selectedUsers.map(user => Number(user.id))),
    ],
    projectId: this.selectedProjectId === null ||
      this.selectedProjectId === ''
        ? null
        : Number(this.selectedProjectId),
  });
},

setBulkCreating(value) {
  this.bulkCreating = value;
},

clearBulkSelection() {
  this.selectedZadanieIds = [];
  this.selectedUsers = [];
  this.selectedProjectId = null;
  this.bulkCreating = false;
},

    getEmptyForm() {
      return {
        title: '',
        description: '',
      };
    },

    show() {
      if (!this.modalObj) {
        this.modalObj = new Modal(this.$refs.modalEle);
      }

      this.modalObj.show();
      this.loadZadania();
    },

    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },

    async loadZadania() {
      this.loading = true;
      this.errorMessage = '';

      try {
        const response = await axios.get(this.apiUrl);
        this.zadaniaLista = response.data;
      } catch (error) {
        this.handleError(error, 'Nie udało się pobrać zadań.');
      } finally {
        this.loading = false;
      }
    },

    addZadanie() {
      this.errorMessage = '';
      this.validationErrors = {};
      this.editingId = null;
      this.originalZadanie = null;
      this.newZadanie = this.getEmptyForm();
      this.addingNew = true;
    },

    cancelNewZadanie() {
      this.addingNew = false;
      this.newZadanie = this.getEmptyForm();
      this.validationErrors = {};
    },

    async saveNewZadanie() {
      if (this.saving) return;

      if (!this.newZadanie.title.trim()) {
        this.validationErrors = {
          title: 'Podaj tytuł zadania.',
        };
        return;
      }

      this.saving = true;
      this.errorMessage = '';
      this.validationErrors = {};

      try {
        const response = await axios.post(this.apiUrl, {
          title: this.newZadanie.title.trim(),
          description: this.newZadanie.description.trim() || null,
        });

        this.zadaniaLista.unshift(response.data);
        this.cancelNewZadanie();
      } catch (error) {
        this.handleError(
          error,
          'Nie udało się dodać zadania.'
        );
      } finally {
        this.saving = false;
      }
    },

    editZadanie(id) {
      const zadanie = this.zadaniaLista.find(
        item => item.id === id
      );

      if (!zadanie) return;

      this.errorMessage = '';
      this.validationErrors = {};
      this.originalZadanie = {
        ...zadanie,
      };
      this.editingId = id;
    },

    cancelEdit(zadanie) {
      if (this.originalZadanie) {
        Object.assign(zadanie, this.originalZadanie);
      }

      this.editingId = null;
      this.originalZadanie = null;
      this.validationErrors = {};
      this.errorMessage = '';
    },

    async updateZadanie(zadanie) {
      if (this.saving) return;

      if (!zadanie.title.trim()) {
        this.validationErrors = {
          ['title_' + zadanie.id]: 'Podaj tytuł zadania.',
        };
        return;
      }

      this.saving = true;
      this.errorMessage = '';
      this.validationErrors = {};

      try {
        const response = await axios.put(
          `${this.apiUrl}/${zadanie.id}`,
          {
            title: zadanie.title.trim(),
            description: zadanie.description?.trim() || null,
          }
        );

        const index = this.zadaniaLista.findIndex(
          item => item.id === zadanie.id
        );

        if (index !== -1) {
          this.zadaniaLista.splice(index, 1, response.data);
        }

        this.editingId = null;
        this.originalZadanie = null;
      } catch (error) {
        this.handleError(
          error,
          'Nie udało się zaktualizować zadania.',
          zadanie.id
        );
      } finally {
        this.saving = false;
      }
    },

    async deleteZadanie(zadanie) {
      if (this.saving) return;

      const confirmed = window.confirm(
        `Czy na pewno chcesz usunąć zadanie „${zadanie.title}”?`
      );

      if (!confirmed) return;

      this.saving = true;
      this.errorMessage = '';

      try {
        await axios.delete(
          `${this.apiUrl}/${zadanie.id}`
        );

        this.zadaniaLista = this.zadaniaLista.filter(
          item => item.id !== zadanie.id
        );

        if (this.editingId === zadanie.id) {
          this.editingId = null;
          this.originalZadanie = null;
        }
      } catch (error) {
        this.handleError(
          error,
          'Nie udało się usunąć zadania.'
        );
      } finally {
        this.saving = false;
      }
    },

    handleError(error, fallbackMessage, zadanieId = null) {
      if (error.response?.status === 422) {
        const errors = error.response.data.errors || {};
        const mappedErrors = {};

        Object.entries(errors).forEach(([field, messages]) => {
          const key =
            field === 'title' && zadanieId
              ? `title_${zadanieId}`
              : field;

          mappedErrors[key] = Array.isArray(messages)
            ? messages[0]
            : messages;
        });

        this.validationErrors = mappedErrors;
        this.errorMessage = '';
        return;
      }

      if (error.response?.status === 403) {
        this.errorMessage =
          'Nie masz uprawnień do zarządzania zadaniami tego działu.';
        return;
      }

      if (error.response?.status === 404) {
        this.errorMessage =
          'Nie znaleziono zadania lub tablicy.';
        return;
      }

      this.errorMessage =
        error.response?.data?.message || fallbackMessage;
    },
  },
};
</script>
